import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { alpha } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ForgotPasswordFormProps } from "_interfaces/auth";
import { FormInputProps } from "_interfaces/_common/forms";
import { ForgotPasswordModel } from "_models/data/auth/data.forgot-password.model";

import Password from "component/_common/forms/password";

import InputText from "component/_common/forms/inputText";
import RouteConstant from "navigation/constant";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { ForgotPasswordErrorModel } from "_models/errors/auth/error.forgot-password.model";
import { validateForgotPassword } from "./formValidator";

interface InputListProps extends FormInputProps {
  name: "phone";
  link?: string;
}

const inputList: InputListProps[] = [
  {
    type: "number",
    name: "phone",
    label: "Phone",
    placeholder: "Enter Phone",
  },
];

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  isProgress,
  handleChangePasswordRequest,
  state,
  setState,
}) => {
  const [errors, setErrors] = useState<ForgotPasswordErrorModel>(
    new ForgotPasswordErrorModel()
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setState((prev) => ({ ...prev, [name]: checked }));
    } else {
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();

    const ValidateStep: {
      valid: boolean;
      errors: { name: string; error: string }[];
    } = validateForgotPassword(state);

    if (ValidateStep?.valid) {
      handleChangePasswordRequest();
    } else {
      for (
        let i = 0, item: { name: string; error: string };
        !!(item = ValidateStep.errors[i++]);

      ) {
        setErrors((prevState) => ({ ...prevState, [item.name]: item.error }));
      }
    }
  };

  return (
    <>
      <Typography
        variant="h1"
        fontSize={36}
        fontWeight={700}
        textAlign="center"
      >
        Forgot Password?
      </Typography>
      <Typography textAlign="center">
        Don’t worry we’ll get your covered, Request for changing password
      </Typography>

      <Box pt={5}>
        <Box
          component="form"
          name="auth_forgot_password_form"
          onSubmit={handleSubmit}
        >
          <Grid container spacing={3}>
            {inputList.map(
              (
                {
                  type,
                  name,
                  label,
                  placeholder,
                  autoComplete,
                  disabled,
                  link,
                },
                index
              ) => (
                <Fragment key={index}>
                  <>
                    {type === "text" ||
                    type === "email" ||
                    type === "number" ? (
                      <Grid item xs={12}>
                        <InputText
                          variant="outlined"
                          type={type}
                          name={name}
                          label={label}
                          placeholder={placeholder}
                          autoComplete={autoComplete || "off"}
                          value={state[name as keyof ForgotPasswordModel]}
                          errorText={
                            errors[name as keyof ForgotPasswordErrorModel]
                          }
                          onChange={handleChange}
                          onFocus={handleFocus}
                          disabled={disabled}
                        />
                      </Grid>
                    ) : type === "password" ? (
                      <Grid item xs={12}>
                        <Password
                          type={type}
                          name={name}
                          label={label}
                          placeholder={placeholder}
                          autoComplete={autoComplete || "off"}
                          value={state[name as keyof ForgotPasswordModel]}
                          errorText={
                            errors[name as keyof ForgotPasswordErrorModel]
                          }
                          onChange={handleChange}
                          onFocus={handleFocus}
                          disabled={disabled}
                          isHideShow
                        />
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </>
                </Fragment>
              )
            )}

            <Grid item xs={12} mt={2}>
              <Box color="black">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disableElevation
                >
                  {isProgress ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Box pt={1} textAlign="center">
            <Link to={RouteConstant.LOGIN}>
              <Button variant="text" color="inherit">
                Back To Login
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ForgotPasswordForm;
